export default __webpack_public_path__ + "static/media/six.dd269c9d.svg";